import { render, staticRenderFns } from "./PolicyDetails.vue?vue&type=template&id=36af8b45&scoped=true"
import script from "./PolicyDetails.vue?vue&type=script&lang=js"
export * from "./PolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetails.vue?vue&type=style&index=0&id=36af8b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af8b45",
  null
  
)

export default component.exports